@if (type() === "status" || content()) {
  {{ content() }}
}
